// @ts-nocheck
import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import StripBannerBlock from "./StripBannerBlock";

export default class NavSliderBlock extends EpiComponent<StripBannerBlock> {
  public render(): ReactNode | ReactNodeArray | null {

    return (
      <>
        <div
          className={"strip-banner-block"}
          style={{ marginBottom: this.props.data?.isSpacingHeight?.value }}>
          <StripBannerBlock
            iContent={this.props?.data}
            context={this.getContext()}
          />
        </div>
      </>
    );
  }
}
